import { Navigate } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { useLicense } from "@/hooks/useLicense";

type Props = {
  children: React.ReactNode;
  /** Skip the license check (e.g. for onboarding pages that must run before purchase). */
  requireLicense?: boolean;
};

export function ProtectedRoute({ children, requireLicense = true }: Props) {
  const { user, loading: authLoading } = useAuth();
  const { hasLicense, loading: licenseLoading } = useLicense(user?.id);

  if (authLoading || (user && requireLicense && licenseLoading)) {
    return (
      <div className="min-h-screen grid place-items-center text-muted-foreground font-mono text-sm">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/auth" replace />;
  if (requireLicense && !hasLicense) return <Navigate to="/checkout/pending" replace />;
  return <>{children}</>;
}
